<ng-template #applyApplication>
  <div class="modal-body">
    <div class="form" [formGroup]="formGroup">
      <div class="panel-item">
        <label class="panel-label">Контакты<span class="required"><sup>*</sup></span></label>
        <input placeholder="+7 (___) ___-____" prefix="+7" mask=" (000) 000 00 00" type="text" class="panel-input" formControlName="clientLogin">
      </div>
      <div class="panel-item">
        <label class="panel-label">Имя<span class="required"><sup>*</sup></span></label>
        <input type="text" formControlName="clientName" class="panel-input" placeholder="Укажите имя">
      </div>
    </div>
   
    <div class="panel-action-btns">
      <app-button
      [buttonClass]="'big-gray-light'"
      (buttonClick)="resetForm()"
      [text]="'Очистить'"
      [styleInline]="{ 'height': '100%' }"
    ></app-button>
      <app-button
      [buttonClass]="'big-purple-gradient'"
      [text]="'Отправить'"
      [disabled]="formGroup.invalid || isSendingApplication"
      (buttonClick)="sendApplication()"
      [styleInline]="{ 'height': '100%', 'width': '100%' }"
    ></app-button>
    </div>
  </div>
</ng-template>

<ng-template #modalSuccess>
  <app-modal-success [title]="'Ваша заявка отправлена!'" [subtitle]="'Свяжемся с вами в ближайшее время!'" (closePanel)="openPanel = $event"></app-modal-success>
</ng-template>

<app-panel [header]="'Заполните форму'" [visible]="openPanel" [template]="isSend ? modalSuccess : applyApplication" (visibleChange)="visibleChange($event)"></app-panel>

